import { render, staticRenderFns } from "./Replicate.vue?vue&type=template&id=7c73510c"
import script from "./Replicate.vue?vue&type=script&lang=js"
export * from "./Replicate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c73510c')) {
      api.createRecord('7c73510c', component.options)
    } else {
      api.reload('7c73510c', component.options)
    }
    module.hot.accept("./Replicate.vue?vue&type=template&id=7c73510c", function () {
      api.rerender('7c73510c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/teacher/Replicate.vue"
export default component.exports